import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleAuth } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState("Autenticazione in corso...");

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sid = params.get("session_id");
      if (!sid) {
        setStatus("Sessione mancante");
        toast.error("Sessione Google mancante");
        setTimeout(() => nav("/login"), 1500);
        return;
      }
      try {
        await googleAuth(sid);
        toast.success("Accesso effettuato");
        nav("/");
      } catch (e) {
        toast.error("Errore autenticazione Google");
        nav("/login");
      }
    };
    run();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex items-center gap-3 text-neutral-700">
        <Loader2 className="h-5 w-5 animate-spin" /> {status}
      </div>
    </div>
  );
}
